import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CategoriaPessoaJuridica } from 'src/app/enums/pessoa-enums/categoria-pessoa-juridica.enum';
import { PessoaService } from 'src/app/services/pessoa.service';

@Component({
    selector: 'app-pessoa-hierarchical-dropdown',
    templateUrl: './pessoa-hierarchical-dropdown.component.html',
    styleUrls: ['./pessoa-hierarchical-dropdown.component.css']
})
export class PessoaHierarchicalDropdownComponent implements OnInit {

    public searchTerm = '';

    public open = false;

    selectedItems: any[] = [];

    public pessoas: any[] = [];

    public loading: boolean = false;

    @Output() selectionChange = new EventEmitter<any[]>();

    private searchText$ = new Subject<string>();
    subscription: Subscription;

    @HostListener('document:click', ['$event'])
    clickOutside(event: Event) {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.open = false;
        }
    }

    get labelSelecionado(): string {

        const total = this.selectedItems.length;

        if (total === 0)
            return 'Todos';

        if (total === 1)
            return '1 selecionado';

        return total + ' selecionados';
    }

    constructor(private elementRef: ElementRef,
        private pessoaService: PessoaService) { }

    ngOnInit(): void {
        this.subscription = this.searchText$
            .pipe(debounceTime(500), distinctUntilChanged())
            .subscribe((value: string) => {
                this.buscarPessoa(value);
            }
            );

        this.buscarPessoa('a');
    }

    buscarPessoa(buscar) {
        this.loading = true;
        this.pessoaService.obterHierarquiaPessoaFiltroNomeAsync(buscar).then(x => {
            this.pessoas = x.data;
            this.loading = false;
        });
    }

    filtrar(term: any) {

        if (term.keyCode == 38 || term.keyCode == 40) return;

        if (term.target.value != '') {
            this.searchText$.next(term.target.value);
        }
    }

    toggle() {
        this.open = !this.open;
    }

    remove(item: any, event: MouseEvent) {

        event.stopPropagation();

        this.selectedItems =
            this.selectedItems.filter(x => x.id !== item.id);

        item.checked = false;

        this.selectionChange.emit(this.selectedItems);
    }

    togglePessoa(pessoa: any) {
        pessoa.expanded = !pessoa.expanded;
    }


    toggleFiliais(pessoa: any) {
        pessoa.expandedFiliais = !pessoa.expandedFiliais;

        if (pessoa.expandedFiliais) {
            pessoa.filiais = [];

            this.pessoaService.obterHierarquiaPessoaFiltroFiltroAsync(pessoa.id, CategoriaPessoaJuridica.Filial).then(x => {
                pessoa.filiais = x.data;
            });
        }
    }

    toggleOrgaosPublicos(pessoa: any) {
        pessoa.expandedOrgaosPublicos = !pessoa.expandedOrgaosPublicos;

        if (pessoa.expandedOrgaosPublicos) {
            pessoa.orgaosPublicos = [];

            if (pessoa.expandedOrgaosPublicos) {

                this.pessoaService.obterHierarquiaPessoaFiltroFiltroAsync(pessoa.id, CategoriaPessoaJuridica.OrgaosEEntePublico).then(x => {
                    pessoa.orgaosPublicos = x.data;
                });
            }
        }
    }


    toggleUnidadeDeNegocio(pessoa: any) {
        pessoa.expandedUnidadeDeNegocio = !pessoa.expandedUnidadeDeNegocio;

        if (pessoa.expandedUnidadeDeNegocio) {
            pessoa.unidadeDeNegocio = [];

            if (pessoa.expandedUnidadeDeNegocio) {

                this.pessoaService.obterHierarquiaPessoaFiltroFiltroAsync(pessoa.id, CategoriaPessoaJuridica.UnidadeNegocio).then(x => {
                    pessoa.unidadeDeNegocio = x.data;
                });
            }
        }
    }

    select(pessoa: any) {
        this.selected(pessoa);
    }

    selectFilial(pessoa: any) {
        this.selected(pessoa);
    }

    selectOrgaosPublicos(pessoa: any) {
        this.selected(pessoa);
    }

    selectUnidadeDeNegocio(pessoa: any) {
        this.selected(pessoa);
    }

    selected(item: any) {
        item.checked != item.checked;

        const index = this.selectedItems.findIndex(x => x.id === item.id);

        if (index >= 0) {
            this.selectedItems.splice(index, 1);
        } else {
            this.selectedItems.push(item);
        }

        this.selectionChange.emit(this.selectedItems);
    }

}
